import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Img from "gatsby-image";
import { IconContext } from "react-icons";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import styles from "./style.module.scss";

export default function Carousel({ items }) {
  const imageBoxRef = useRef();
  const [displayLeft, setDisplayLeft] = useState(false);
  const [displayRight, setDisplayRight] = useState(true);

  function onScroll() {
    const { scrollLeft, scrollWidth, clientWidth } = imageBoxRef.current;

    if (scrollLeft !== 0) {
      setDisplayLeft(true);
    } else {
      setDisplayLeft(false);
    }
    if (scrollLeft !== scrollWidth - clientWidth) {
      setDisplayRight(true);
    } else {
      setDisplayRight(false);
    }
  }

  function handleScroll(direction) {
    const interval = window.innerWidth / 3;
    const current = imageBoxRef.current.scrollLeft;

    const scroll = position =>
      imageBoxRef.current.scrollTo({
        left: position,
        behavior: "smooth"
      });

    switch (direction) {
      case "left":
        scroll(current - interval);
        break;

      case "right":
        scroll(current + interval);
        break;

      default:
        throw new Error("You've provided an invalid value to handleScroll()");
    }
  }

  const Button = ({ direction, display, children }) => (
    <button
      type="button"
      className={cx({
        [styles.button]: true,
        [styles.display]: display
      })}
      onClick={() => handleScroll(direction)}
    >
      {children}
    </button>
  );

  return (
    <div className={styles.container}>
      <Button direction="left" display={displayLeft}>
        <IconContext.Provider value={{ size: "1em", className: styles.icon }}>
          <FaArrowLeft />
        </IconContext.Provider>
      </Button>
      <div
        className={styles.imageContainer}
        ref={imageBoxRef}
        onScroll={onScroll}
      >
        {items.map(item => (
          <div className={styles.image}>
            <Img
              loading="eager"
              fluid={item.node.image.fluid}
              key={item.node.name}
              alt={item.node.name}
              title={item.node.name}
            />
          </div>
        ))}
      </div>
      <Button direction="right" display={displayRight}>
        <IconContext.Provider value={{ size: "1em", className: styles.icon }}>
          <FaArrowRight />
        </IconContext.Provider>
      </Button>
    </div>
  );
}

Carousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired
};
